import { i18n } from './i18n';
export function initI18nWithoutICU(options) {
    return i18n(options);
}
//# sourceMappingURL=initI18nWithoutICU.js.map